import { Button, Stack, Typography, TextField } from "components";
import { PatientInput, PatientType } from "types";
import PatientOption from "./PatientOption";
import { OPTIONS, DISCLAIMER } from "./constants";

interface PatientPickerProps {
  patient: PatientInput;
  onTypeChange(type: PatientType): void;
  onRelationChange(relation: string): void;
  onNext?(): void;
}

const PatientPicker: React.FC<PatientPickerProps> = ({
  patient,
  onTypeChange,
  onRelationChange,
  onNext,
}) => {
  const optionsContainerStyle = {
    width: "100%",
    display: "grid",
    gridTemplateColumns: "auto auto",
    gap: "8px",
  };

  return (
    <Stack direction="column" gap={3} placeItems="flex-end">
      <Stack
        direction="column"
        gap={3}
        style={{ width: "80%", placeSelf: "center" }}
      >
        <Typography align="center">Who is the patient?</Typography>
        <Stack gap={2} direction="column" placeItems="center">
          <div style={optionsContainerStyle}>
            {OPTIONS.map((option) => {
              return (
                <PatientOption
                  key={option.label}
                  image={option.image}
                  label={option.label}
                  active={patient?.type === option.value}
                  onClick={() => onTypeChange(option.value)}
                />
              );
            })}
          </div>
          {patient.type === "others" && (
            <TextField
              placeholder="What is your relation to the patient?"
              value={patient.relation}
              onChange={(e) => onRelationChange(e.target.value)}
            />
          )}
        </Stack>
        <Typography component="p" size={-1} color="#9e9e9e" align="center">
          {DISCLAIMER}
        </Typography>
      </Stack>
      <Button
        filled
        onClick={onNext}
        disabled={!onNext}
        iconEnd="arrow_forward"
      >
        Continue
      </Button>
    </Stack>
  );
};

export { PatientPicker };
